export default {
  addShopSuccess: 'Produto adicionado com sucesso',
  addShopFail: 'Falha ao adicionar produto',
  getCartDataFail: 'Falha ao obter produtos do carrinho',
  hint: 'Dica',
  delConfirmProduct: 'Tem certeza de que deseja excluir o produto?',
  confirm: 'Confirmar',
  cancel: 'Cancelar',
  productInfo: 'Detalhes do produto',
  unitPrice: 'Preço unitário',
  num: 'Quantidade',
  subtotal: 'Subtotal',
  action: 'Operação',
  productName: 'Nome do produto',
  splitProduct: 'Dividir produto',
  split: 'Dividir',
  allSelect: 'Selecionar todos',
  delProduct: 'Excluir produto',
  selected: 'Selecionado',
  piece: 'peça',
  total: 'Total',
  productTotal: 'Não inclui taxa de entrega internacional',
  orderPay: 'Fazer pedido e pagar',
  orderTotal: 'Total do pedido',
  goCartPay: 'Ir para pagamento do carrinho',
  moreView: 'Mais carrinho',
  noSelectText: 'Ainda não selecionou produtos',
  paySuccess: 'Pagamento bem-sucedido!',
  returnPayment: 'Voltar para continuar pagando',
  service: 'Serviço',
  goodsMinNumErrTips:
    'Este produto requer uma quantidade mínima de compra de {num}, você pode escolher diferentes especificações conforme necessário.',
  balckShop: 'Loja na lista negra',
  forbidBuy: 'Produto de risco, compra proibida',
  riskTip: 'Produto de risco, compre com cuidado',
  riskReminder: 'Lembrete de risco',
  blackenedShop: 'Loja na lista negra',
  riskProducts: 'Produtos de risco',
  riskMsg1:
    'Os produtos que você enviou podem ter certos riscos. Para a segurança de seus fundos, não podemos fornecer serviços de pedido online temporariamente. Para mais informações, entre em contato com o atendimento ao cliente ou departamento de compras especializado.',
  riskMsg2:
    'Os produtos que você enviou podem ter certos riscos de envio. Para a segurança de seus fundos, não podemos fornecer serviços de pedido online temporariamente. Para mais informações, entre em contato com o atendimento online!',
  riskMsg3:
    'Os produtos que você comprou podem ser produtos profissionais ou de marca. Não temos a capacidade de verificar sua autenticidade e só podemos fornecer serviços de compra e inspeção básica de qualidade. Qualquer risco potencial deve ser assumido por você.',
  continueToBuy: 'Continuar comprando outros',
  buyOthers: 'Comprar outros',
  continuePurchasing: 'Continuar comprando',
}
